import type { MutationUpdaterFn } from '@apollo/client';

import { updateCache } from 'src/modules/apollo/apolloCache';
import type * as Schema from 'src/types/graphql';

export const updateCacheUpdateQualification: MutationUpdaterFn<
  Schema.UpdateQualificationMutation
> = (cache, { data }) => {
  const { updateQualification } = data || {};
  const confirmedQualifications =
    updateQualification?.viewer?.confirmedQualifications;

  // Update cache with server data
  if (confirmedQualifications) {
    updateCache({
      cache,
      data: confirmedQualifications,
      fieldName: 'confirmedQualifications',
    });
  }
};

export const updateCacheUpdateVerifiedQualification: MutationUpdaterFn<
  Schema.UpdateVerifiedQualificationMutation
> = (cache, { data }) => {
  const { updateVerifiedQualification } = data || {};
  const confirmedQualifications =
    updateVerifiedQualification?.viewer?.confirmedQualifications;

  // Update cache with server data
  if (confirmedQualifications) {
    updateCache({
      cache,
      data: confirmedQualifications,
      fieldName: 'confirmedQualifications',
    });
  }
};

export const updateCacheDeleteQualification: MutationUpdaterFn<
  Schema.DeleteQualificationMutation
> = (cache, { data }) => {
  const { deleteQualification } = data || {};
  const confirmedQualifications =
    deleteQualification?.viewer?.confirmedQualifications;

  // Update cache with server data
  if (confirmedQualifications) {
    updateCache({
      cache,
      data: confirmedQualifications,
      fieldName: 'confirmedQualifications',
    });
  }
};

export const updateCacheConfirmQualification: MutationUpdaterFn<
  Schema.ConfirmQualificationMutation
> = (cache, { data }) => {
  const { confirmQualification } = data || {};
  const confirmedQualifications =
    confirmQualification?.viewer?.confirmedQualifications;
  const unconfirmedQualifications =
    confirmQualification?.viewer?.unconfirmedQualifications;

  // Update cache with server data
  if (confirmedQualifications) {
    updateCache({
      cache,
      data: confirmedQualifications,
      fieldName: 'confirmedQualifications',
    });
  }
  if (unconfirmedQualifications) {
    updateCache({
      cache,
      data: unconfirmedQualifications,
      fieldName: 'unconfirmedQualifications',
    });
  }
};

export const updateCacheConfirmJobsDbQualification: MutationUpdaterFn<
  Schema.ConfirmQualificationJobsDbMutation
> = (cache, { data }) => {
  const { confirmQualification } = data || {};
  const confirmedQualifications =
    confirmQualification?.viewer?.confirmedQualifications;
  const unconfirmedQualifications =
    confirmQualification?.viewer?.unconfirmedQualifications;

  // Update cache with server data
  if (confirmedQualifications) {
    updateCache({
      cache,
      data: confirmedQualifications,
      fieldName: 'confirmedQualifications',
    });
  }
  if (unconfirmedQualifications) {
    updateCache({
      cache,
      data: unconfirmedQualifications,
      fieldName: 'unconfirmedQualifications',
    });
  }
};

export const updateCacheRejectQualification: MutationUpdaterFn<
  Schema.RejectQualificationMutation
> = (cache, { data }) => {
  const { rejectUnconfirmedData } = data || {};

  // Refresh store with server data
  if (rejectUnconfirmedData?.viewer?.unconfirmedQualifications) {
    const { unconfirmedQualifications } = rejectUnconfirmedData.viewer;
    updateCache({
      cache,
      data: unconfirmedQualifications,
      fieldName: 'unconfirmedQualifications',
    });
  }
};
